import React, { useEffect, useState } from "react";
import { BsPencil } from "react-icons/bs";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import profile_Img from "../../../../Assets/Images/user.png";
import NewProfileModal from "../../../../Pages/SetupProfile/AboutUserProfile/NewProfileModal/NewProfileModal";
import { toast } from "react-toastify";
import NewProfileAvtarModal from "../../../../Pages/SetupProfile/NewProfile/NewProfileModal/NewProfileModal";

export default function SettingsEdit({
  setView,
  isLoading,
  handleUpdateProfile,
}) {
  const { userInfo } = useSelector((state) => state.authUser);
  const [image, setImage] = useState();
  const [imageFile, setImageFile] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showAvtarModal, setShowAvtarModal] = useState(false);

  useEffect(() => {
    if (userInfo) {
      formik.setValues({
        fullName: userInfo.name || "",
        userName: userInfo.userName || "",
        email: userInfo.email || "",
        phone: userInfo.phone || "",
        gender: userInfo.gender || "",
        about: userInfo.about || "",
        visibility: userInfo.privacy || "",
        countryCode: userInfo.countryCode || "",
      });
      if (userInfo.avtarImage) {
        setImage(userInfo.avtarImage);
      } else {
        setImage(userInfo.userMedia || userInfo.userImage);
      }
    }
  }, [userInfo]);

  const validationSchema = Yup.object({
    fullName: Yup.string()
      .test("no-blank", "Full name cannot be empty", (value) =>
        value?.trim() ? true : false
      )
      .max(30, "Full name cannot exceed 30 characters")
      .min(3, "Full name must be at least 3 characters")
      .required("Full name is required"),
    userName: Yup.string()
      .test("no-blank", "User name cannot be empty", (value) =>
        value?.trim() ? true : false
      )
      .max(30, "User name cannot exceed 30 characters")
      .min(3, "User name must be at least 3 characters")
      .required("User name is required")
      .test("is-valid-username", "User name is invalid", function (value) {
        const usernameRegex = /^[a-zA-Z0-9_.-]{3,}$/;
        return usernameRegex.test(value);
      }),
    email: Yup.string().email("Invalid email").required("Email is required"),
    phone: Yup.string().required("Phone number is required"),
    gender: Yup.string().required("Gender is required"),
    about: Yup.string().required("About is required"),
    visibility: Yup.string().required("Visibility is required"),
    countryCode: Yup.string().required("Country code is required"),
  });

  const formik = useFormik({
    initialValues: {
      fullName: "",
      userName: "",
      email: "",
      phone: "",
      gender: "",
      about: "",
      visibility: "",
      countryCode: "",
    },
    validationSchema,
    onSubmit: (values) => {
      handleUpdateProfile({
        ...values,
        imageFile,
      });
    },
  });

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 10 * 1024 * 1024) {
      toast.error("Image size should be less than 10MB");
      return;
    }
    if (file) {
      setImageFile(file);
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
    }
  };

  return (
    <>
      <section>
        <div className="bg-white border-b pb-0">
          <div className="profile-section p-4 pt-6 rounded-lg max-w-md flex flex-col justify-center items-center gap-4 text-center mx-auto">
            <div className="avatar relative">
              <div className="w-[160px] h-[160px] rounded-full overflow-hidden">
                <img
                  src={image || profile_Img}
                  alt="profile"
                  className="w-full h-full object-cover"
                />
              </div>
              <label
                htmlFor="file-upload"
                className="bg-[var(--primary-color)] absolute top-0 right-4 w-fit rounded-full p-2 cursor-pointer hover:opacity-50 z-30"
              >
                <BsPencil className="text-white text-xl" />
              </label>
              <input
                type="file"
                id="file-upload"
                accept=".jpg,.png"
                onChange={handleImageChange}
                style={{ display: "none" }}
              />
            </div>
          </div>
          <p
            onClick={() => setShowAvtarModal(true)}
            className="text-lg text-center font-normal my-6 mt-2 underline text-[#7104F8] cursor-pointer"
          >
            Select Avatar
          </p>
        </div>

        <form
          className="p-4 space-y-4 max-w-md mx-auto"
          onSubmit={formik.handleSubmit}
        >
          {/* Full Name */}
          <div className="w-full">
            <label className="text-sm text-[#7C7C7C]">Full Name</label>
            <input
              type="text"
              name="fullName"
              placeholder="Enter Full Name"
              value={formik.values.fullName}
              onChange={formik.handleChange}
              maxLength={30}
              className="w-full border px-3 py-2.5 mt-2 rounded-lg border-[#EBEBEB] outline-none text-sm"
            />
            {formik.touched.fullName && formik.errors.fullName && (
              <div className="text-red-500 text-xs">
                {formik.errors.fullName}
              </div>
            )}
          </div>
          {/* user Name */}
          <div className="w-full">
            <label className="text-sm text-[#7C7C7C]">User Name</label>
            <input
              type="text"
              name="userName"
              placeholder="Enter User Name"
              value={formik.values.userName}
              onChange={formik.handleChange}
              className="w-full border px-3 py-2.5 mt-2 rounded-lg border-[#EBEBEB] outline-none text-sm"
            />
            {formik.touched.userName && formik.errors.userName && (
              <div className="text-red-500 text-xs">
                {formik.errors.userName}
              </div>
            )}
          </div>

          {/* Email */}
          <div className="w-full">
            <label className="text-sm text-[#7C7C7C]">Mail</label>
            <input
              type="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              className="w-full border px-3 py-2.5 mt-2 rounded-lg border-[#EBEBEB] outline-none text-sm"
              disabled
            />
            {formik.touched.email && formik.errors.email && (
              <div className="text-red-500 text-xs">{formik.errors.email}</div>
            )}
          </div>

          {/* Phone */}
          <div className="w-full">
            <label className="text-sm text-[#7C7C7C]">Phone Number</label>
            <PhoneInput
              country={"us"}
              value={
                formik.values.countryCode.replace("+", "") + formik.values.phone
              }
              onChange={(phone, data) => {
                const dialCode = data?.dialCode || "";
                const number = phone.slice(dialCode.length);
                formik.setFieldValue("countryCode", `+${dialCode}`);
                formik.setFieldValue("phone", number);
              }}
              inputProps={{ name: "phone" }}
              inputClass="!w-full !py-2.5 !pl-14 !pr-4 !rounded-lg !border !border-[#EBEBEB] !text-sm"
              containerClass="!w-full"
              buttonClass="!bg-transparent !border-none !outline-none !px-3"
              dropdownClass="!z-50"
              disabled
            />
            {formik.touched.phone && formik.errors.phone && (
              <div className="text-red-500 text-xs">{formik.errors.phone}</div>
            )}
          </div>

          {/* Gender */}
          <div className="w-full">
            <label className="text-sm text-[#7C7C7C]">Gender</label>
            <select
              name="gender"
              value={formik.values.gender}
              onChange={formik.handleChange}
              className="w-full border px-3 py-2.5 mt-2 rounded-lg border-[#EBEBEB] outline-none text-sm bg-white"
            >
              <option value="Female">Female</option>
              <option value="Male">Male</option>
              <option value="Other">Other</option>
            </select>
            {formik.touched.gender && formik.errors.gender && (
              <div className="text-red-500 text-xs">{formik.errors.gender}</div>
            )}
          </div>

          {/* About */}
          <div className="w-full">
            <label className="text-sm text-[#7C7C7C]">About</label>
            <div
              onClick={() => setIsModalOpen(true)}
              className="select bg-white select-bordered rounded-lg min-h-[48px] w-full flex items-center px-3 cursor-pointer"
            >
              <p className="line-clamp-2 py-2 text-sm">
                {formik.values.about || "Enter About You"}
              </p>
            </div>
            {formik.touched.about && formik.errors.about && (
              <div className="text-red-500 text-xs">{formik.errors.about}</div>
            )}
          </div>

          {/* Visibility */}
          <div className="w-full">
            <label className="text-sm text-[#7C7C7C]">
              Who can see your phone number
            </label>
            <select
              name="visibility"
              value={formik.values.visibility}
              onChange={formik.handleChange}
              className="w-full border px-3 py-2.5 mt-2 rounded-lg border-[#EBEBEB] outline-none text-sm bg-white"
            >
              <option value="Everyone">Everyone</option>
              <option value="Friends">Friends</option>
              <option value="Nobody">Nobody</option>
            </select>
            {formik.touched.visibility && formik.errors.visibility && (
              <div className="text-red-500 text-xs">
                {formik.errors.visibility}
              </div>
            )}
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-4 pt-2">
            <button
              type="button"
              onClick={() => setView("view")}
              className="px-4 w-50 py-3 text-sm border hover:opacity-50 border-gray-300 rounded-full"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 w-50 py-3 text-sm bg-[var(--primary-color)] hover:opacity-50 text-white rounded-full"
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Save"}
            </button>
          </div>
        </form>
      </section>
      <NewProfileModal
        isOpen={isModalOpen}
        onSave={(selectedAbout) => {
          formik.setFieldValue("about", selectedAbout);
          setIsModalOpen(false);
        }}
        isAbout={formik.values.about}
        onClose={() => setIsModalOpen(false)}
      />
      <NewProfileAvtarModal
        isOpen={showAvtarModal}
        onSave={(avatar) => {
          setImageFile(avatar._id);
          setImage(avatar.avtarImage);
          setShowAvtarModal(false);
        }}
        onClose={() => setShowAvtarModal(false)}
      />
    </>
  );
}
